import CustomerExtended, { ICustomerExtendedDto } from "./CustomerExtended"

export interface ICustomerItemDto extends ICustomerExtendedDto {
    isErpCustomer: boolean
    language?: string | null
    termsOfPaymentCode?: string | null
}

export default class CustomerItem extends CustomerExtended {
    #isErpCustomer: boolean
    language?: string
    termsOfPaymentCode?: string

    constructor(dto: ICustomerItemDto) {
        super(dto)
        this.#isErpCustomer = dto.isErpCustomer
        this.language = dto.language || undefined
        this.termsOfPaymentCode = dto.termsOfPaymentCode || undefined
    }

    print(): string {
        return [
            this.number,
            this.name,
            this.address?.printZipCity(),
            this.currency,
        ].filter(t => !!t).join(" | ")
    }

    printShort(): string {
        return [
            this.number,
            this.name,
        ].filter(t => !!t).join(" | ")
    }

    get isErpCustomer(): boolean {
        return this.#isErpCustomer
    }
}
